export default __webpack_public_path__ + "b054ee4f2672b0eafb8350395ba8fbb9.png";